import { APCard, APColumn, APImage, APRow, APText } from "ap-components";
import MandateModel from "../../Models/Mandate";

export function BankAccount({ mandate }: { mandate: MandateModel }) {
    return (
        <APCard style={{ padding: "8px", border: "solid 1px #e2e6ef", borderRadius: "8px" }}>
            <APColumn gap="4px" mainAxisAlignment="start" crossAxisAlignment="start">
                <APRow gap="8px">
                    <APImage height={24} src={`/img/banks/ic_${mandate.getBankIcon()}.svg`} />
                    <APText style={{ fontSize: "16px", lineHeight: 1.5, color: "#232730" }}>{mandate.bankName ?? mandate.IFSC.substring(0, 4)}</APText>
                </APRow>
                <APColumn mainAxisAlignment="start" crossAxisAlignment="start" gap="4px" style={{ paddingLeft: "32px" }}>
                    <APText style={{ fontSize: "14px", lineHeight: 1.43, color: "#606c84" }}>{mandate.accountNumber}</APText>
                    <APText style={{ fontSize: "14px", lineHeight: 1.43, color: "#606c84" }}>{mandate.getBankType()}</APText>
                    <APText style={{ fontSize: "14px", lineHeight: 1.43, color: "#606c84" }}>IFSC: {mandate.IFSC}</APText>
                </APColumn>
            </APColumn>
        </APCard>
    );
}
